module.exports = __webpack_public_path__ + "static/Contact_Illustration-74a003f5154cc649b4aeb9ca2bb4ab0a.png";